// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__UlCfN","icon":"Search_icon__HYRxb"};